module.exports = __webpack_public_path__ + "img/citrus.c3f9443c.png";